import { Grid } from "@mui/material";
import { useStyles } from "./instruction-banner-style";
import { RenderHTML } from "components/sanitizeHtml/sanitizeHtml";

interface InstructionBannerProps {
  message: string;
}

export const InstructionBanner = ({ message }: InstructionBannerProps) => {
  const classes = useStyles();

  return (
    <Grid className={`${classes.gridContainer} instruction-banner`.trim()}>
      <RenderHTML content={message} />
    </Grid>
  );
};
